import React from 'react';

import { Svg, type SvgProps } from './svg';

export function CalendarIcon(props: SvgProps) {
  return (
    <Svg data-testid="calendar-icon" {...props}>
      <path d="M5 22c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.927 1.927 0 0 1 5 4h1V2.975c0-.283.096-.517.287-.7A.993.993 0 0 1 7 2a.97.97 0 0 1 .713.287A.97.97 0 0 1 8 3v1h8V2.975c0-.283.096-.517.288-.7A.99.99 0 0 1 17 2c.283 0 .52.096.712.287.192.192.288.43.288.713v1h1c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 19 22H5Zm0-2h14V10H5v10Z" />
    </Svg>
  );
}
